export enum AppPermissions {
  // Base permissions used currently
  ADMIN = 'Admin',
  INVOICING = 'Invoicing',
  COST = 'Cost',
  FINANCIAL = 'Financial',
  DATA_QUALITY = 'DataQuality',
  RENEWAL = 'Renewal',
  TIME_REGISTRATION = 'TimeRegistration',
  BUDGET_MANAGEMENT = 'Budget_Management',
  CLIENT_PORTAL = 'ClientPortal',
  PROSPECTION = 'Prospection',
  EPO = 'EPO',
  FINANCIAL_PRICEMAINTAINER = 'Financial_PricesMaintainer',
  FEE_CALCULATOR = 'FeeCalculator',
  FEE_CALCULATOR_CONFIGURATION = 'FeeCalculator_Configuration',
  HR = 'HR',

  //new permissions to be set
  ANALYTICS_FULL = 'Analytics_Full',
  STATS_REPORTING = 'StatsReporting',
  INVOICING_BASIC = 'Invoicing_Basic',
  SUBSIDIES_BASIC = 'Subsidies_Basic',
  BADPAYERS_MANAGEMENT = 'BadPayers_Management',
  INVOICING_REPORTING = 'Invoicing_Reporting',
  INVOICING_FULL = 'Invoicing_Full',
  INVOICING_CONFIGURATION = 'Invoicing_Configuration',
  WORKCODES_CONFIGURATION = 'Workcodes_Configuration',
  BANK_REPORTING = 'Bank_Reporting',
  PAVIS = 'Pavis',
  RENEWALS_CONFIGURATION = 'Renewals_Configuration',
  TIMEREGISTRATION_CONFIGURATION = 'TimeRegistration_Configuration',
  TEAMS_MANAGER = 'TeamsManager',
  GENERAL_MANAGEMENT = 'General_Management',
  TEMPLATE_ENGINE_CONFIGURATION = 'TemplateEngine_Configuration',
  COMPANY_MANAGEMENT_FULL = 'Company_Management_Full',
  EMPLOYEE_MANAGEMENT = 'Employee_Management',
  COMPANY_MANAGEMENT_BASIC = 'Company_Management_Basic',
  ClIENT_PORTAL_MANAGEMENT_FULL = 'ClientPortal_Management_Full',
  CASESCONVERSION_INFO = 'CasesConversion_Info',
  CRM_BASIC = 'CRM_Basic',
  CRM_CONFIGURATION = 'CRM_configuration',
  TIMEREGISTRATION_MANAGEMENT = 'TimeRegistration_Management',
  EXTERNAL = 'External',
  MATTER_ATTENTION = 'MatterAttention',
  CRYSTALX_RULE_QUEUE_READ = 'CrystalXRuleQueueRead',
  CRYSTALX_RULE_LEGAL_APPROVAL = 'CrystalXRuleLegalApproval',
  CRYSTALX_RULE_TECHNICAL_APPROVAL = 'CrystalXRuleTechnicalApproval',
  // Dark-ship gate (P11): CrystalX is merged but hidden until this is granted. Admin passes as everywhere.
  CRYSTALX_ACCESS = 'CrystalX_Access',
  PAYMENTS_RECONCILIATION = 'Payments_Reconciliation',
  PAYMENTS_BANK_CONNECTION = 'Payments_BankConnection',
  PAYMENTS_INITIATE = 'Payments_Initiate',
  // P108: AI docketing queue, Confirm/Ignore and the Mail queue (writes Patricia, costs AI calls). Ships granted to nobody.
  AI_DOCKETING_USE = 'AiDocketing_Use',
  // P127 S1: Crystal OA workspace (AI office-action brief, strategy, reports). Ships granted to nobody.
  OFFICE_ACTION_USE = 'OfficeAction_Use',
  // P246: create/edit/deactivate Peppol routing rules (Joris first, finance later). Ships granted to nobody.
  PEPPOL_ROUTING_EDIT = 'PeppolRouting_Edit',
}

// Providers: viewing matches GET api/Provider; add/edit/delete matches POST/PUT/DELETE api/Provider (P107, P143).
export const PROVIDER_VIEW_PERMISSIONS: AppPermissions[] = [
  AppPermissions.COST,
  AppPermissions.INVOICING_FULL,
  AppPermissions.PAYMENTS_INITIATE,
  AppPermissions.PAYMENTS_RECONCILIATION,
  AppPermissions.ADMIN,
];
export const PROVIDER_MAINTAINER_PERMISSIONS: AppPermissions[] = [
  AppPermissions.INVOICING_FULL,
  AppPermissions.PAYMENTS_INITIATE,
  AppPermissions.PAYMENTS_RECONCILIATION,
  AppPermissions.ADMIN,
];
